import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  MnemoCallout,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";
import {
  dateHelper,
  learningService,
  lessonOnSiteService,
  networkErrorHelper,
} from "libs";
import { ROUTES } from "const";
import { Icon, Button } from "design-react-kit";

class CourseLessonOnSiteScheduleAll extends Component {
  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    onsites: [],
    liveClass: null,
    lessonCreditRecognition: [],
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });
    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemote(course.id, userCourse.registrationCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(courseId, rCode) {
    lessonOnSiteService
      .MyScheduleOnSite(courseId, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          onsites: data.payload.lessonOnSites,
          liveClass: data.payload.lessonOnSiteClasses,
          sections: data.payload.sections,
          lessonCreditRecognition: data.payload.lessonCreditRecognition || [],
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  goDetail = (idLessonOnSite) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSONONSITE_DETAIL}/${rCode}/${idLessonOnSite}`;
  };

  getLocation = (onsite) => {
    let location = "";

    // verify if the location exists by region
    if (onsite.location && this.state.userCourse.pluginConfig?.region) {
      const tLocation = JSON.parse(onsite.location);
      location =
        tLocation[this.state.userCourse.pluginConfig.region.toUpperCase()] || "";

      // Replace all hyphens with double <br /> for HTML line breaks
      const lines = String(location)
        .split(/\r\n|\n\r|\r|\n/)
        .map(s => s.trim())
        .filter(Boolean);
      location = lines.map(s => `&bull; ${s}`).join("<br />");
    } else {
      // show the first location if the region is not set
      const tLocaltion = JSON.parse(onsite.location);
      const keys = Object.keys(tLocaltion);
      location = tLocaltion[keys[0]];
    }
    return location;
  };

  renderOnSites(onsites, userCourse, lessonCreditRecognition) {
    let creditRecognition = false;
    if (userCourse && userCourse.creditRecognition) {
      creditRecognition = userCourse.creditRecognition;
    }

    return (
      <MSection className="m-2">
        {onsites.length > 0 && (
          <>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Data</th>
                  <th scope="col">Attività Formativa</th>
                  <th scope="col">Ora inizio</th>
                  <th scope="col">Ora fine</th>
                  <th scope="col">Sede</th>
                  <th scope="col">Insegnamento</th>
                  <th scope="col">Docente</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {onsites.map((onsite, i) => {

                  const checkLessonCreditRecognition = (lessonCreditRecognition || []).filter((item) => { return item.lessonId === onsite.id && item.lessonType === "lessonOnSite" && item.registrationCode === this.state.rCode });

                  return (
                    <tr key={i}>
                      <td>{dateHelper.toITDate(onsite.date)}</td>
                      <td>{onsite.sectionTitle}</td>
                      <td>{dateHelper.toShortTime(onsite.hourStart)}</td>
                      <td>{dateHelper.toShortTime(onsite.hourEnd)}</td>
                      <td>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: this.getLocation(onsite),
                          }}
                        />
                      </td>
                      <td>{onsite.subject}</td>
                      <td>{onsite.teacher}</td>
                      <td>
                        {((creditRecognition &&
                          onsite.creditRecognition &&
                          onsite.creditRecognition.includes(creditRecognition)) || checkLessonCreditRecognition.length === 1) ? (
                          <>
                            <p className="btn btn-outline-primary m-1">
                              Attività da non frequentare a seguito di
                              riconoscimento
                            </p>
                          </>
                        ) : (
                          <></>
                        )}
                        {
                          <Button
                            id="radio"
                            color="primary bg-dark m-1 btn-block"
                            onClick={(e) => {
                              this.goDetail(onsite.id);
                            }}
                          >
                            Dettaglio
                          </Button>
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </MSection>
    );
  }

  render() {
    const {
      loading,
      loadingError,
      onsites,
      rCode,
      userCourse,
      lessonCreditRecognition,
    } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
        </BoxDanger>
      );

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Lezioni in presenza</Title>
        {this.renderOnSites(onsites, userCourse, lessonCreditRecognition)}
        <div className="m-2">
          <MnemoCallout>
            <p>Calendario in continuo aggiornamento.</p>
          </MnemoCallout>
        </div>
      </>
    );
  }
}

export default withRouter(CourseLessonOnSiteScheduleAll);
